namespace GeniuzPOS.LogManage {
    export class LogUserLockErrorPasswordColumns {
        static columnsKey = 'LogManage.LogUserLockErrorPassword';
    }
}
